import React from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import {Button} from 'react-bootstrap'
import game_dikha from './asset/game_dikha.mp4'
import game from './asset/game.png'
import { Link } from 'react-scroll';
import { NavLink } from 'react-router-dom';
import Rest from './Rest'


const GameDikha = () => {
    var styles={
        

    }
  
    return (
        <div className="gamedikha">
        <header >   
        <div className="overlay" ></div>
          <video  playsinline="playsinline" autoplay="autoplay" muted="false" loop="loop" >
          <source src={game_dikha} type="video/mp4"/>
       </video>
       <div className="container" style={{position:"relative"}}>
        <img src = {game}/>
        <div>
       <Link to="reg" smooth="true"> <Button className="btn-danger">Register Now !!</Button></Link>
        </div>
        
        </div>
       
       </header>
       
       </div>
      
       
    );

}

export {GameDikha };
